import { lazy, Suspense } from "react";

import { MULTI_ANALYSIS_MEASURE_TYPE, type IMultiAnalysisDataMark } from "../../../multi-analysis/types";
import type { ISpeedScreenFormContentProps, ISpeedScreenFormStrategy, ISpeedScreenFormTimePanelProps } from "../types";
import { isNyquistDataMark } from "./model";
import { NyquistTimePanel } from "./time-panel";
import { NyquistDataMarkTooltip } from "./tooltip";

const NyquistScreenForm = lazy(() => import("./view").then(module => ({ default: module.NyquistScreenForm })));

export class NyquistScreenFormStrategy implements ISpeedScreenFormStrategy {
  readonly id = "nyquist" as const;
  readonly titleId = "pages.speed.screenForms.nyquist";
  readonly measureType = MULTI_ANALYSIS_MEASURE_TYPE.POLAR_TREND;

  render(props: ISpeedScreenFormContentProps) {
    return (
      <Suspense fallback={null}>
        <NyquistScreenForm {...props} />
      </Suspense>
    );
  }

  renderTimePanel(props: ISpeedScreenFormTimePanelProps) {
    return <NyquistTimePanel {...props} />;
  }

  renderDataMarkTooltip(mark: IMultiAnalysisDataMark) {
    return isNyquistDataMark(mark) ? <NyquistDataMarkTooltip mark={mark} /> : null;
  }
}
